import {
    extractProperties,
    isEmpty,
} from '.'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'
import {NinchatTagUpdatedEvent} from '../types/events'

export const tagUpdated: CaseReducer<NinchatState> = (state, action) => {
    const {
        realm_id,
        tag_id,
        tag_attrs,
        ...rest
    } = extractProperties<NinchatTagUpdatedEvent>(action.payload)

    isEmpty(rest)

    if (realm_id) {
        const {parent_id} = tag_attrs

        if (parent_id) {
            const tag = state._tags[realm_id][parent_id].tag_children[tag_id]
            tag.tag_attrs = tag_attrs
        } else {
            const tag = state._tags[realm_id][tag_id]
            tag.tag_attrs = tag_attrs
        }
    }
}
